import { render, staticRenderFns } from "./ApprovalConfigurationInstanceDetailInput.vue?vue&type=template&id=38718299&scoped=true&"
import script from "./ApprovalConfigurationInstanceDetailInput.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfigurationInstanceDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalConfigurationInstanceDetailInput.vue?vue&type=style&index=0&id=38718299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38718299",
  null
  
)

export default component.exports